import connect from './connect';

export { UserActivityReportScreen } from './UserActivityReportScreen';

export default connect;
